import { SecondaryColors, TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';
import { canHover } from '@picsart/design-system/foundation/styleHelpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { clickable: boolean }>(
  () => ({
    header: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s16,
      marginBottom: Spacings.s48,
      textAlign: 'center',
    },
    title: {
      fontWeight: FontWeights.bold,
      fontSize: FontSizes.s42,
    },
    desc: {
      fontSize: FontSizes.s20,
    },
    content: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: Spacings.s24,
      marginBottom: Spacings.s16,
      [BreakPointsMedia.MD]: {
        gap: Spacings.s32,
      },
    },
    item: {
      display: 'flex',
      gap: Spacings.s12,
      padding: Spacings.s16,
      boxSizing: 'border-box',
      flex: `1 0 calc(25% - ${Spacings.s24})`,
      maxWidth: `calc(25% - ${Spacings.s24})`,
      borderRadius: CornerRadius.r12,
      [BreakPointsMedia.LG]: {
        flex: `1 0 calc(33% - ${Spacings.s24})`,
        maxWidth: `calc(33% - ${Spacings.s24})`,
      },
      [BreakPointsMedia.SM]: {
        flex: '1 0 100%',
        maxWidth: '100%',
        padding: Spacings.s0,
      },
      [BreakPointsMedia.XS]: {
        flex: '1 0 100%',
        maxWidth: '100%',
        padding: Spacings.s0,
      },
      [BreakPointsMedia.XXS]: {
        flex: '1 0 100%',
        maxWidth: '100%',
        padding: Spacings.s0,
      },
      [canHover]: {
        '&:hover': {
          boxShadow: ({ clickable }) =>
            clickable
              ? `${Spacings.s0} ${Spacings.s0} ${Spacings.s16} ${Spacings.s0} rgba(0,0,0,0.2)`
              : null,
          cursor: ({ clickable }) => (clickable ? 'pointer' : null),
          '& $itemTitle': {
            color: ({ clickable }) => (clickable ? SecondaryColors.base.default : null),
          },
        },
      },
    },
    itemIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '64px',
      height: '64px',
      borderRadius: CornerRadius.r8,
      backgroundColor: SecondaryColors.alpha.alpha20,
    },
    itemInfo: {
      flex: 1,
    },
    itemTitle: {
      color: TextColors.base,
      fontWeight: FontWeights.bold,
      fontSize: FontSizes.s16,
      marginBottom: Spacings.s4,
    },
    itemDesc: {
      color: TextColors.tint1,
      fontSize: FontSizes.s14,
    },
  }),
  {
    name: 'feature-list',
  },
);

export default useStyles;
